import React from 'react';
import IntlMessages from 'util/IntlMessages';
import { withRouter } from 'react-router-dom';
const UserInfo = ({ user, onSignOut, history }) => {
    return (
        <div>
            <div className="user-profile">
                <span className="user-avatar bg-blue border-0 size-40">
                    <h3 className="m-0 text-white text-uppercase">
                        {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
                    </h3>
                </span>
                <div className="user-detail ml-2">
                    <h4 className="user-name mb-0">{`${user.firstName} ${user.lastName}`}</h4>
                    <small>{user.role.name}</small>
                </div>
            </div>
            <a
                className="dropdown-item text-muted"
                href="javascript:void(0)"
                onClick={() => history.push('/app/profile')}
            >
                <i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
                Profil
            </a>
            <a className="dropdown-item text-muted" href="javascript:void(0)" onClick={onSignOut}>
                <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
                Abmelden
            </a>
        </div>
    );
};

export default withRouter(UserInfo);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js